import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxInputPassword from "src/components/input/SfxInputPassword.vue"
import { useAuthStore } from "src/stores/authStore"
import { Log } from "src/util/classes/log"
import { hashUnlockKey } from "src/util/functions/hashing"
import { showErrorNotification, showSuccessNotification } from "src/util/functions/notifications"
import { ref } from "vue"
import { useI18n } from "vue-i18n"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogChangeUnlockKey',
  setup(__props) {

const { t } = useI18n()
const authStore = useAuthStore()
const { dialogRef, onDialogCancel, onDialogOK } = useDialogPluginComponent()
const currentPassword = ref("")
const unlockKey = ref("")

//endregion

//region Lifecycle
//endregion

//region Functions

async function setNewUnlockKey() {
  try {
    const hashResult = await hashUnlockKey(unlockKey.value)
    if (hashResult) {
      authStore.setUnlockKeyHashed(hashResult)

      showSuccessNotification(t("sfxDialogChangeUnlockKey.msg_unlock_key_changed"))
    } else {
      showErrorNotification(t("sfxErrorMsg.error_change_unlock_key"))
      Log.error({ message: "Failed to hash Unlock key." })
    }
  } catch (error) {
    showErrorNotification(t("sfxErrorMsg.error_change_unlock_key"))
    Log.error({ message: "Failed to set new Unlock key.", error })
  } finally {
    onDialogOK()
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-change-unlock-key"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pa-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogChangeUnlockKey.title_change_unlock_key")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_form, { onSubmit: setNewUnlockKey }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "q-px-lg q-pb-lg q-pt-none q-gutter-sm" }, {
                default: _withCtx(() => [
                  _createVNode(SfxInputPassword, {
                    modelValue: currentPassword.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
                    label: _ctx.$t('sfxDialogChangeUnlockKey.input_current_password'),
                    autocomplete: "current-password"
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(SfxInputPassword, {
                    modelValue: unlockKey.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unlockKey).value = $event)),
                    label: _ctx.$t('sfxDialogChangeUnlockKey.input_unlock_key'),
                    autocomplete: "new-key"
                  }, null, 8, ["modelValue", "label"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { class: "q-px-lg q-pt-lg q-mt-xl" }, {
                default: _withCtx(() => [
                  _createVNode(SfxBtnOutline, {
                    class: "col q-mr-md",
                    label: _ctx.$t('sfxButtons.btn_cancel'),
                    onClick: _unref(onDialogCancel)
                  }, null, 8, ["label", "onClick"]),
                  _createVNode(SfxBtn, {
                    class: "col",
                    label: _ctx.$t('sfxButtons.btn_save'),
                    disable: !currentPassword.value || !unlockKey.value,
                    type: "submit"
                  }, null, 8, ["label", "disable"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})